import * as React from 'react'
import { Query } from 'react-apollo'

import { ExternalSchool_externalSchool } from 'main/gql/externalSchool'
import { SchoolListingType } from 'main/gql/globalTypes'
import { SchoolPage_school } from 'main/pages/School/gql'
import { UnreachableCaseError } from 'main/util/ts'
import Content from './Content'
import {
  RELATED_PROGRAMS_QUERY,
  RelatedPrograms as RelatedProgramsData,
  RelatedProgramsVariables,
} from './gql'

interface IProps {
  school: SchoolPage_school | ExternalSchool_externalSchool
  type: SchoolListingType
}

export default function RelatedPrograms(props: IProps) {
  const {
    school: { id, address },
    type,
  } = props
  const { latitude, longitude } =
    address && address.latitude !== null && address.longitude !== null
      ? { latitude: address.latitude, longitude: address.longitude }
      : { latitude: 0, longitude: 0 }

  return (
    <Query<RelatedProgramsData, RelatedProgramsVariables>
      query={RELATED_PROGRAMS_QUERY}
      variables={queryVariables()}
    >
      {result => {
        return <Content result={result} />
      }}
    </Query>
  )

  function queryVariables() {
    const base: RelatedProgramsVariables = {
      limit: 4,
      location: {
        byCenter: {
          coords: { latitude, longitude },
          radius: 10,
        },
      },
    }

    switch (type) {
      case SchoolListingType.EXTERNAL:
        return { ...base, excludeExternalSchoolIds: [id] }
      case SchoolListingType.INTERNAL:
        return { ...base, excludeSchoolIds: [id] }
      default:
        throw new UnreachableCaseError(type)
    }
  }
}
